// The signed-in user snapshot that lives in localStorage under "user".
//
// Its `role` field is the SESSION role — 'student' | 'recruiter' | 'admin' —
// and it is what ProtectedRoute in App.jsx compares against. It is NOT the
// same thing as `Recruiter.role` in the database, which stores the person's
// job title ("Founder", "Hiring Manager", "HR") and is very often the empty
// string. The two fields collide by name, so spreading a profile response over
// the session snapshot silently rewrites the session role to a job title. The
// user stays logged in as far as the server is concerned — the JWT is
// untouched and still valid — but every protected route then fails its role
// check and bounces them out, which reads to them as being logged out.
//
// Anything that folds server-side profile data into the session must go
// through mergeProfileIntoSession so that can't happen again.

// Fields that identify the session itself. A profile payload may never
// overwrite them.
const IDENTITY_KEYS = ['id', 'role'];

/**
 * Merge a profile response into the stored session user, keeping the session's
 * own identity fields authoritative.
 *
 * @param {object} session Current session snapshot (parsed localStorage "user").
 * @param {object} profile Profile document returned by the API.
 * @returns {object} A new snapshot — profile fields applied, identity preserved.
 */
export function mergeProfileIntoSession(session, profile) {
  const merged = { ...(session || {}) };
  Object.entries(profile || {}).forEach(([key, value]) => {
    if (IDENTITY_KEYS.includes(key)) return;
    merged[key] = value;
  });
  return merged;
}

export default mergeProfileIntoSession;
